import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {useAppDispatch, useLanguage, useModal} from "../../../../hooks/hooks";
import {useCallback} from "react";
import {TermsCategory} from "../../../../types/terms";
import {CartVoucherState} from "../../../../types/order";
import {useTranslation} from "react-i18next";
import {PaymentWay} from "../../../../types/payment";
import {CartedProduct} from "../../../../types/cart";
import {getCartsAsync, setCartedProducts} from "../../../../store/cart/cartSlice";

export function useOrderFunctions() {
    const {t} = useTranslation("order")
    const dispatch = useAppDispatch();

    const { language } = useLanguage();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const {openAlertModal} = useModal();
    const cartIdxes = getCartIdxesFromQueryParam();
    const location = useLocation();

    const state = location.state as CartVoucherState | null;
    const currentVoucherType = state?.type ?? "voucher";

    function getCartIdxesFromQueryParam(): number[] {
        const cartIdxes =
            searchParams
                .get("cart-idxes")
                ?.split(",")
                ?.map((it) => parseInt(it)) ?? [];
        if (cartIdxes.length === 0) {
            openAlertModal({
                title: "안내",
                desc: "잘못된 접근입니다.",
            });
            navigate(`/purchase-voucher`);
            return [];
        }

        return cartIdxes;
    }

    // 약관 링크 처리 함수
    const onClickTermsLink = useCallback((e: React.MouseEvent) => {
        window.open(`${process.env.REACT_APP_BASE_URL}terms?terms_category=${TermsCategory.PAYMENT_TERMS}`, "_blank");
        e.stopPropagation();
    }, []);

    // url에서 idx값으로 주문하려는 상품정보 조회
    const getCarts = useCallback(async () => {
        try {
            const cartedProducts: CartedProduct[] = await dispatch(getCartsAsync(cartIdxes)).unwrap();
            dispatch(setCartedProducts(cartedProducts));
        } catch (error) {
            console.error(error);
            openAlertModal(null);
        }
    }, [dispatch, openAlertModal, cartIdxes]);


    // 결제하기 버튼 클릭 시 밸리데이션
    const onClickPayBtn = useCallback((
        {isAgreed, paymentWay, pay}: { isAgreed: boolean, paymentWay: PaymentWay | null, pay: (_:boolean) => void }
    ) => {
        if (!isAgreed) {
            openAlertModal({
                title: t("modal.title"),
                desc: t("modal.agreement"),
            });
            return;
        }

        if (!paymentWay) {
            openAlertModal({
                title: t("modal.title"),
                desc: t("modal.paymentMethod"),
            });

            return;
        }

        pay(true);
    // eslint-disable-next-line
    },[]);

    // 브라우저와 상품 언어 다른지 체크
    const validateProductLanguage = (cartedProduct: CartedProduct[]) => {
        cartedProduct.forEach(cart => {
            if (cart.product.language !== language) {
                alert("상품언어와 브라우저 언어가 다릅니다\n다시 시도해주세요.");
                window.location.href = "/purchase-voucher"
            }
        })
    }

    return {
        onClickTermsLink,
        currentVoucherType,
        getCarts, cartIdxes,
        onClickPayBtn,
        validateProductLanguage
    }
}